import { Button } from '@citizen-walk/shared-ui';

export interface RecoveryOverwriteConfirmProps {
  /** この端末に既にある参加情報のニックネーム (不明なら null)。 */
  existingNickname: string | null;
  /** 復帰コードの持ち主のニックネーム (不明なら null)。 */
  incomingNickname: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
}

/**
 * 復帰の上書き確認 (docs/98 R-70 P6)。
 *
 * 他人の端末で復帰コードを使うと、その端末の持ち主の参加情報 (ニックネーム・参加セッション・復帰コード)
 * が黙って置き換わる事故を防ぐため、サーバが `existing-membership` で止めたときに表示する。
 * QR 自動復帰 (RecoveryAutoPage) と手入力 (RecoveryRecoverModal) の両方で使う。
 * 文言は内部識別子を出さず、一般の参加者が判断できる日本語にする。
 */
export function RecoveryOverwriteConfirm({
  existingNickname,
  incomingNickname,
  onConfirm,
  onCancel,
  busy = false,
}: RecoveryOverwriteConfirmProps) {
  const existing = existingNickname ?? '別の参加者';
  const incoming = incomingNickname ?? '復帰コードの持ち主';
  return (
    <div
      role="alert"
      data-testid="recovery-overwrite-confirm"
      className="rounded-md border border-warning-300 bg-warning-50 p-3 text-sm text-warning-900 text-left"
    >
      <p className="font-medium mb-2">この端末の参加情報を置き換えますか？</p>
      <p className="mb-1">この端末には「{existing}」として参加した記録があります。</p>
      <p className="mb-1">
        復帰すると、この端末の参加情報は「{incoming}」のものに置き換わり、「{existing}
        」の復帰コードはこの端末では使えなくなります。
      </p>
      <p className="mb-3">
        自分の復帰コードでない場合や、借りている端末の場合は「やめる」を押してください。
      </p>
      <Button variant="primary" size="md" onClick={onConfirm} disabled={busy} className="w-full">
        置き換えて復帰する
      </Button>
      <Button
        variant="secondary"
        size="md"
        onClick={onCancel}
        disabled={busy}
        className="w-full mt-2"
      >
        やめる
      </Button>
    </div>
  );
}
